import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GridComponent, ExcelExportEvent } from '@progress/kendo-angular-grid';
import { MatDialog } from '@angular/material/dialog';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { ICommentsInputModel, ICommentsListOutputModel, IPeerReviewDedOutputModel } from 'src/app/ViewModel/PeerReviewModel';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DatePipe } from "@angular/common";


@Component({
  selector: 'app-add-comments',
  templateUrl: './add-comments.component.html',
  styleUrls: ['./add-comments.component.css']
})
export class AddCommentsComponent implements OnInit {
  @Input() Data: any;
  @Output() exitFunc: EventEmitter<any> = new EventEmitter();
  public commentList: ICommentsListOutputModel[] = [];
  public disciplineDropdown: IPeerReviewDedOutputModel[] = [];
  public potentialcmd: any[] = ['Type 1- DESIGN TEAM TO ADDRESS','Type 2- DESIGN TEAM TO ADDRESS WITH BU/Contract'];
  public categoryDropdown: IPeerReviewDedOutputModel[] = [];
  public editRowIndex !: number;
  public editedRowIndex: any;
  public editedProduct: any;
  public setDisable: boolean = false;
  public formGroup!: FormGroup;
  public disc: string | null = '';
  public count: number = 1;
  public toggle: boolean = false;
  public memberId !: number;
  public commentdate: string = '';
  public enableFilter: boolean = false;
  public isAdmin: boolean = false;
  public memberList: any[];
  public selectedMember: number = null;

  @ViewChild(GridComponent)
  private grid!: GridComponent;
  showReqno: boolean;
  requestNum: string;

  constructor(private dialog: MatDialog, private commentsListService: PeerReviewService, public notificationService: NotificationService,
    private mapRoleFeatureService: MapRoleFeatureService, private commonService: CommonService, private _formBuilder: FormBuilder, private _fileService: FileService) {
  }

  ngOnInit() {
    if (!this.Data) {
      if (this.commonService.redirectUserToPRAddComments) {
        let reqNo = this.commonService.redirectUserToPRAddComments_ReqNo;
        this.showReqno = (reqNo != null);
        if (this.showReqno) {
          this.requestNum = reqNo;
        }
        this.Data = { 'requestNo': this.requestNum }
      }
      else {
        const urlParams = new URLSearchParams(window.location.search);
        let reqNo = urlParams.get('reqno');
        const projId = urlParams.get('proj');
        this.Data = { 'requestNo': reqNo }
        this.showReqno = (reqNo != null);
        if (this.showReqno) {
          this.requestNum = reqNo;
        }
      }
    }
    this.memberId = this.commonService.getLoggedInUserId();
    this.getComments();
    this.commentsListService.getPeerStatus({ strDocNumber: this.Data.requestNo, intUID: this.memberId }).subscribe(res => {
      let meeting = res.filter(x => x.action_Desc == "Meeting Completed");
      let date: Date = new Date(meeting[0].action_On);
      date.setDate(date.getDate() + 3);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.commentdate = datePipe.transform(date, 'dd-MMM-yyyy');
    });
    this.allData = this.allData.bind(this);

    this.commentsListService.getPeerPanelMembers({strDocNumber: this.Data.requestNo, intUID: this.memberId}).subscribe((resPanel)=>
    {
      this.memberList = resPanel.filter(x => x.member_category == 'ROLE-BASED');
      this.isAdmin = (resPanel.filter(x => x.member_Id == this.memberId)).length?false:true;
    });
  }

  memberSelection(event: any) {
    if (event.value>0)
      this.selectedMember = event.value;
    else
      this.selectedMember = null;
  }

  ngAfterViewInit() {
    this.grid.editRow(0);
  }

  createFormGroup() {
    this.formGroup = this._formBuilder.group({
      'discipline': new FormControl('', Validators.required),
      'comments': new FormControl('', Validators.required),
      'potential_comment': new FormControl('', Validators.required),
      'category': new FormControl('', Validators.required),
      'discipline2': new FormControl('', Validators.required),
      'comments2': new FormControl('', Validators.required),
      'category2': new FormControl('', Validators.required),
      'potential_comment2': new FormControl('', Validators.required),
      'cid': new FormControl('', Validators.required),
    });
  }

  getComments() {
    this.commentList = [];
    let obj = {
      'review_No': this.Data.requestNo,
      'member_Id': this.memberId
    }
    this.commentsListService.getReviewComments(obj).subscribe((data: ICommentsListOutputModel[]) => {
      this.commentList[0] = {
        review_No: this.Data.requestNo,
        discipline: null,
        disc_No: null,
        disc_DE_Id: null,
        disc_DED_Id: null,
        comment_Id: null,
        panel_Comments: null,
        potential_Comment: null,
        category: null,
        category_DE_Id: null,
        category_DED_Id: null,
        comment_By: null,
        comment_On: null
      }
      this.commentList = this.commentList.concat(data);
      for (let i = 0; i < this.commentList.length; i++) {
        if (i == 0) {
          this.count = 1;
          this.disc = this.commentList[0].disc_No;
        }
        let _x: any = this.commentList[i].disc_No
        if (this.commentList[i].disc_No && this.disc == this.commentList[i].disc_No) {
          this.commentList[i].disc_No = _x + this.count;
          this.count++;
        }
        else {
          this.count = 1;
          this.disc = this.commentList[i].disc_No

          this.commentList[i].disc_No = _x + this.count;
          this.count++;
        }
      }
    });
    this.commentsListService.getCommentData(this.Data.requestNo).subscribe(data => {
      this.disciplineDropdown = data.commentDiscipline;
      this.categoryDropdown = data.commentCategory;
    });
    this.createFormGroup();
  }

  public editHandler({ sender, rowIndex, dataItem }: any) {
    let temp1 = this.formGroup.value.discipline2;
    let temp2 = this.formGroup.value.comments2;
    let temp3 = this.formGroup.value.category2;
    let temp4 = this.formGroup.value.potential_comment2;
    this.editRowIndex = rowIndex;
    this.formGroup = new FormGroup({
      'discipline': new FormControl(dataItem.disc_DED_Id),
      'comments': new FormControl(dataItem.panel_Comments),
      'potential_comment': new FormControl(dataItem['potential_Comment']),
      'category': new FormControl(dataItem.category_DED_Id),
      'discipline2': new FormControl(temp1),
      'comments2': new FormControl(temp2),
      'category2': new FormControl(temp3),
      'potential_comment2': new FormControl(temp4),
      'cid': new FormControl(dataItem.comment_Id),
    });
    this.closeEditor(sender);
    this.editedRowIndex = rowIndex;
    this.editedProduct = Object.assign({}, dataItem);
    sender.editRow(rowIndex);
    this.grid.editRow(0);
  }

  public cancelHandler({ sender, rowIndex }: any) {
    this.closeEditor(sender, rowIndex);
    this.grid.editRow(0);
  }

  public newSave(dataItem: any) {
    dataItem = this.formGroup.value;
    if (!dataItem.discipline2) {
      this.notificationService.showToast("Please Select any one in Discipline", "Warning");
      return;
    }
    if (!dataItem.comments2) {
      this.notificationService.showToast("Please Enter Comments", "Warning");
      return;
    }
    if (!dataItem.potential_comment2) {
      this.notificationService.showToast("Please select Yes/No for Potential Comment For Future Jobs", "Warning");
      return;
    }
    if (!dataItem.category2) {
      this.notificationService.showToast("Please Select any one in Category", "Warning");
      return;
    }
    if (!!dataItem) {
      let selectedDiscipline = this.disciplineDropdown.filter(data => data.deD_Id == dataItem.discipline2)[0];
      let selectedCategory = this.categoryDropdown.filter(data => data.deD_Id == dataItem.category2)[0];
      let obj: ICommentsInputModel = {
        Review_No: this.Data.requestNo,
        Save_Type: "PARTIAL",
        Panel_Comments: dataItem.comments2,
        Potential_Comment: dataItem.potential_comment2,
        Disc_DE_Id: selectedDiscipline.dE_Id,
        Disc_DED_Id: selectedDiscipline.deD_Id,
        Category_DE_Id: selectedCategory.dE_Id,
        Category_DED_Id: selectedCategory.deD_Id,
        Attachment_Available: "N",
        UID: this.commonService.getLoggedInUserId(),
        On_Behalf: this.selectedMember
      }
      this.commentsListService.postReviewComments(obj).subscribe(data => {
        if (data.strErrorMsg == null) {
          this.notificationService.showToast("Peer review comments inserted successfully.", "Success");
          this.getComments();
        }
        else {
          this.notificationService.showToast(data.strErrorMsg, "Warning");
        }
      });
      for (let i = 1; i <= this.commentList.length; i++) {
        this.grid.closeRow(i);
      }
    }
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
  }

  public saveHandler({ sender, rowIndex, dataItem, isNew }: any) {
    let isAttachment = dataItem.isAttachment;
    dataItem = this.formGroup.value;
    if (!dataItem.discipline) {
      this.notificationService.showToast("Please Select any one in Discipline", "Warning");
      return;
    }
    if (!dataItem.comments) {
      this.notificationService.showToast("Please Enter Comments", "Warning");
      return;
    }
    if (!dataItem.potential_comment) {
      this.notificationService.showToast("Please select Yes/No for Potential Comment For Future Jobs", "Warning");
      return;
    }
    if (!dataItem.category) {
      this.notificationService.showToast("Please Select any one in Category", "Warning");
      return;
    }
    if (!!dataItem) {
      let selectedDiscipline = this.disciplineDropdown.filter(data => data.deD_Id == dataItem.discipline)[0];
      let selectedCategory = this.categoryDropdown.filter(data => data.deD_Id == dataItem.category)[0];
      let obj: ICommentsInputModel = {
        Review_No: this.Data.requestNo,
        Save_Type: "PARTIAL",
        Panel_Comments: dataItem.comments,
        Potential_Comment: dataItem.potential_comment,
        Disc_DE_Id: selectedDiscipline.dE_Id,
        Disc_DED_Id: selectedDiscipline.deD_Id,
        Category_DE_Id: selectedCategory.dE_Id,
        Category_DED_Id: selectedCategory.deD_Id,
        Attachment_Available: isAttachment,
        UID: this.commonService.getLoggedInUserId(),
        Comment_Id: dataItem.cid,
        On_Behalf: this.selectedMember
      }
      this.commentsListService.postReviewComments(obj).subscribe(data => {
        if (data.strErrorMsg == null) {
          this.notificationService.showToast("Peer review comments updated successfully.", "Success");
          this.getComments();
        }
        else {
          this.notificationService.showToast(data.strErrorMsg, "Warning");
        }
      });
    }
    sender.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
  }

  private closeEditor(grid: any, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
    this.selectedMember = null;
  }

  public viewAttachmentClick(dataItem: any) {
    const dialog = this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary'],
      data: {
        projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRC', libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: dataItem.isResponseRecived == 'N' ? true : false      },
    });
    dialog.afterClosed().subscribe((res: any) => {
      this.getComments();
    });
  }

  uploadAttachmentClick(dataItem: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: {
        projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRC', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.commonService.getLoggedInUserId(),
        documents: [{ value: dataItem.comment_Id, text: 'EDMS', revisionNo: 'PRC', task_SNo: 0 }],
        isEditable: false,isEnableFullScreen:true
      },
    });
    dialog.afterClosed().subscribe((res: any) => {
      const dialog2 = this.dialog.open(FileListComponent, {
        panelClass: ['mat-dialog-secondary'],
        data: {
          projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRC', libraryName: FileUploadLibrary.WorkflowDocument,
          createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: true
        },
      });
      dialog2.afterClosed().subscribe((res: any) => {
        this._fileService.GetFiles({
          libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(
            { projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRC' }
          )
        }).subscribe((_data: any[]) => {
          let x: string;
          _data.length > 0 ? x = 'Y' : x = 'N'
          if (dataItem.isAttachment != x) {
            dataItem.isAttachment = x

            let obj: ICommentsInputModel = {
              Review_No: this.Data.requestNo,
              Save_Type: "PARTIAL",
              Panel_Comments: dataItem.panel_Comments,
              Potential_Comment: dataItem.potential_Comment,
              Disc_DE_Id: dataItem.disc_DE_Id,
              Disc_DED_Id: dataItem.disc_DED_Id,
              Category_DE_Id: dataItem.category_DE_Id,
              Category_DED_Id: dataItem.category_DED_Id,
              Attachment_Available: x,
              UID: this.commonService.getLoggedInUserId(),
              Comment_Id: dataItem.comment_Id,
            }
            this.commentsListService.postReviewComments(obj).subscribe();
          }
        });
      });
    });
  }

  onChange() {
    this.toggle = !this.toggle;
  }

  Submit() {
    if (!this.toggle) {
      this.notificationService.showToast("Please complete the declaration before proceeding to Final Submit", "Warning");
      return;
    }
    this.notificationService.showPopup("No more entries can be done after the Submission. Are you sure you want to Submit your Comments?", 'Confirm').then(data => {
      if (data == 'yes') {
        let obj: ICommentsInputModel = {
          Review_No: this.Data.requestNo,
          Save_Type: "FINAL",
          Disc_DE_Id: 0,
          Disc_DED_Id: 0,
          Category_DE_Id: 0,
          Category_DED_Id: 0,
          Attachment_Available: "N",
          UID: this.commonService.getLoggedInUserId()
        }
        this.commentsListService.postReviewComments(obj).subscribe(data => {
          if (data.strErrorMsg == null) {
            this.notificationService.showToast("Peer review Final Comments submitted successfully.", "Success");
            this.exitFunc.emit(true);
          }
          else {
            this.notificationService.showToast(data.strErrorMsg, "Warning");
          }
        });
      }
    });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.commentList.map((data, indx) => ({
        ...data,
        SNO: indx,
        Discipline_No: data.disc_No,
        Comment_Status: data.comment_Id ? 'SAVED' : 'UNSAVED',
      }))
    };
    return result;
  }

  public onExcelExport(e: ExcelExportEvent): void {
    e.workbook.sheets[0].columns.forEach((data ,i) => {
      data.width=i==3 ? 250:10;
      data.autoWidth = i==3 ? false:true;
    })

    let values = e.workbook.sheets[0].rows;
    values.splice(1, 1)
    values[0].height = 40;
    values[0].cells[4].wrap=true;
    for(let i=0;i<e.workbook.sheets[0].columns.length;i++)
    {
      values[0].cells[i].background='#507bd1'
      values[0].cells[i].color = "#ffffff"
      values[0].cells[i].textAlign="center"
      values[0].cells[i].verticalAlign="center"
      values[0].cells[i].wrap=true;
    }
    for (let i = 1; i < values.length; i++) {
      values[i].height = values[i].cells[3].value.length > 50 ? (values[i].cells[3].value.length/4)*3.25:48;
      if (values[i].cells[6].value == 'High Risk') { values[i].cells[5].background = '#ff0000';values[i].cells[5].color="#fff";values[i].cells[5].bold=true; }
      if (values[i].cells[6].value == 'Medium Risk') { values[i].cells[5].background = '#ffbf00';values[i].cells[5].color="#fff";values[i].cells[5].bold=true; }
      if (values[i].cells[6].value == 'Low Risk') { values[i].cells[5].background = '#007800';values[i].cells[5].color="#fff";values[i].cells[5].bold=true; }
      values[i].cells[3].wrap=true;
    }
    for(var i=1;i<values.length;i++)
    {
      for(var j=0;j<e.workbook.sheets[0].columns.length;j++)
      {
        if(j==3 || j==6 || j==7)
        {
          values[i].cells[j].textAlign="left"
          values[i].cells[j].verticalAlign="top"
        }
        else{
          values[i].cells[j].textAlign = "center"
          values[i].cells[j].verticalAlign ="center"
        }
        if(i!=0 && j!=5)
        {
          values[i].cells[j].background = (i+1)%2 ? '#eff3fb' : '#ffffff';
        }
        values[i].cells[j].borderTop={color:'#000',size:1};
        values[i].cells[j].borderBottom={color:'#000',size:1};
        values[i].cells[j].borderLeft={color:'#000',size:1};
        values[i].cells[j].borderRight={color:'#000',size:1};
        
      }
    }
  }

}